import _export from "../internals/export";
import _functionUncurryThis from "../internals/function-uncurry-this";
import _requireObjectCoercible from "../internals/require-object-coercible";
import _toString from "../internals/to-string";
var $ = _export;
var uncurryThis = _functionUncurryThis;
var requireObjectCoercible = _requireObjectCoercible;
var toString = _toString;
var charCodeAt = uncurryThis("".charCodeAt);

// `String.prototype.isWellFormed` method
// https://tc39.es/ecma262/#sec-string.prototype.iswellformed
$({
  target: "String",
  proto: true
}, {
  isWellFormed: function isWellFormed() {
    var S = toString(requireObjectCoercible(this));
    var length = S.length;
    for (var i = 0; i < length; i++) {
      var charCode = charCodeAt(S, i);
      // single UTF-16 code unit
      if ((charCode & 63488) !== 55296) continue;
      // unpaired surrogate
      if (charCode >= 56320 || ++i >= length || (charCodeAt(S, i) & 64512) !== 56320) return false;
    }
    return true;
  }
});
export default {};